import { render, staticRenderFns } from "./DataListTabs.vue?vue&type=template&id=56041e54&scoped=true"
import script from "./DataListTabs.vue?vue&type=script&lang=js"
export * from "./DataListTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56041e54",
  null
  
)

export default component.exports